export default __webpack_public_path__ + "static/media/referrals.bd9b7a88.svg";